import { z } from 'zod';

/**
 * „Nachname, Vorname“ → „Vorname Nachname“. So liefert Entra ID die Anzeigenamen; gespeichert bleibt das Original,
 * damit Listen weiter nach Nachname sortieren – nur die Anzeige dreht. Ohne genau ein Komma bleibt der Name
 * unverändert, die Funktion lässt sich also gefahrlos mehrfach anwenden.
 */
export function vorNachname(name: string): string {
  const teile = name.split(',');
  if (teile.length !== 2) return name;
  const nachname = teile[0]!.trim();
  const vorname = teile[1]!.trim();
  return nachname && vorname ? `${vorname} ${nachname}` : name;
}

/**
 * Name einer Person in einer API-Antwort. Der Client dreht ihn beim Einlesen (`apiAufruf`), damit Portal und
 * Verwaltung überall „Vorname Nachname“ zeigen; die API selbst liefert das gespeicherte Original.
 */
export const PersonenNameSchema = z.string().transform(vorNachname);
